module.exports = __webpack_public_path__ + "static/img/bg-1.f4866238.png";